import React from 'react';
import { PARAGRAPH_TOGGLE } from './types';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';

const ParagraphToggleElement = dynamicEditorComponent(() =>
  import('./ParagraphToggleElement').then((mod) => mod.ParagraphToggleElement)
);

export const renderElementParagraphToggle = (options?: any) => (props) => {
  const { element } = props;

  if (element.type === PARAGRAPH_TOGGLE) {
    return <ParagraphToggleElement {...props} />;
  }

  return undefined;
};
